/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Dashboards
05.Pages
06.Applications
  06.01.Chat
  06.02.Survey
  06.03.Todo
07.UI
  07.01.Alerts
  07.02.Badges
  07.03.Buttons
  07.04.Cards
  07.05.Carousel
  07.06.Charts
  07.07.Collapse
  07.08.Dropdowns
  07.09.Editors
  07.10.Forms
  07.11.Form Components
  07.12.Icons
  07.13.Input Groups
  07.14.Jumbotron
  07.15.Modal
  07.16.Navigation
  07.17.Popover & Tooltip
  07.18.Sortable
  07.19.Maps
  07.20.Tables
*/

const ruMessages = {
  /* 01.General */
  'general.copyright': 'Myma.ai © 2019 All Rights Reserved.',

  /* 02.User Login, Logout, Register */
  'user.login-title': 'Авторизоваться',
  'user.register': 'регистр',
  'user.forgot-password': 'Забыли пароль',
  'user.email': 'Эл. адрес',
  'user.newpassword': 'новый пароль',
  'user.currentpassword': 'действующий пароль',
  'user.newpasswordagain': 'Новый пароль еще раз',
  'user.password': 'Пароль',
  'user.forgot-password-question': 'Забыть пароль?',
  'user.fullname': 'ФИО',
  'user.firstname': 'Имя',
  'user.lastname': 'Фамилия',
  'user.login-button': 'АВТОРИЗОВАТЬСЯ',
  'user.register-button': 'РЕГИСТР',
  'user.reset-password-button': 'СБРОС НАСТРОЕК',
  'user.buy': 'КУПИТЬ',
  'user.username': 'Имя пользователя',

  /* 03.Menu */
  'menu.app': 'Дом',

  'menu.default': 'По умолчанию',
  'menu.analytics': 'Аналитика',
  'menu.ecommerce': 'Электронная торговля',
  'menu.content': 'Содержание',
  'menu.pages': 'Страницы',
  'menu.data-list': 'Список данных',
  'menu.thumb-list': 'Список миниатюр',
  'menu.image-list': 'Список изображений',
  'menu.details': 'Подробности',
  'menu.search': 'Поиск',
  'menu.login': 'Авторизоваться',
  'menu.register': 'регистр',
  'menu.forgot-password': 'Забыли пароль',
  'menu.error': 'Ошибка',
  'menu.applications': 'Приложения',
  'menu.todo': 'Список дел',
  'menu.survey': 'Опрос',
  'menu.chat': 'Чат',
  'menu.ui': 'интерфейс',
  'menu.edit': 'Редактировать',
  'menu.alerts': 'Оповещения',
  'menu.badges': 'Значки',
  'menu.buttons': 'Кнопки',
  'menu.cards': 'Открытки',
  'menu.carousel': 'Карусель',
  'menu.charts': 'Графики',
  'menu.collapse': 'Крах',
  'menu.dropdowns': 'Выпадающие списки',
  'menu.editors': 'Редакторы',
  'menu.form-layouts': 'Макеты форм',
  'menu.form-components': 'Компоненты формы',
  'menu.form-validations': 'Проверка формы',
  'menu.icons': 'Иконки',
  'menu.input-groups': 'Входные группы',
  'menu.jumbotron': 'Джамботрон',
  'menu.modal': 'Модальный',
  'menu.navigation': 'Навигация',
  'menu.popover-tooltip': 'Всплывающее окно и всплывающая подсказка',
  'menu.sortable': 'Сортируемый',
  'menu.tables': 'Столы',
  'menu.menu': 'Меню',
  'menu.subhidden': 'Доброе утро',
  'menu.hidden': 'Скрытый',
  'menu.visible': 'Видимый',
  'menu.maps': 'Карты',
  'menu.landingpage': 'Целевая страница',
  'menu.multipage-home': 'Многостраничная домашняя страница',
  'menu.singlepage-home': 'Главная страница',
  'menu.about': 'О',
  'menu.auth-login': 'Авторизация Войти',
  'menu.auth-register': 'Регистрация авторизации',
  'menu.blog': 'Блог',
  'menu.blog-detail': 'Детали блога',
  'menu.careers': 'Карьера',
  'menu.confirmation': 'Подтверждение',
  'menu.contact': 'Контакт',
  'menu.docs': 'Документы',
  'menu.features': 'Функции',
  'menu.prices': 'Цены',
  'menu.videos': 'Ролики',
  'menu.mailing': 'Почтовое отправление',
  'menu.invoice': 'Счет',
  'menu.blank-page': 'Скоро будет...',
  'menu.types': 'Типы меню',
  'menu.levels': 'Уровни меню',
  'menu.third-level-1': 'Третий уровень 1',
  'menu.third-level-2': 'Третий уровень 2',
  'menu.third-level-3': 'Третий уровень 3',

  /* 04.Dashboards */
  'dashboards.update': 'Обновить',
  'dashboards.save': 'Сохранить',
  'dashboards.saveSchedule': 'Сохранить расписание',
  'dashboards.pending-orders': 'Заказы в ожидании',
  'dashboards.completed-orders': 'Выполненные заказы',
  'dashboards.refund-requests': 'Запросы на возврат',
  'dashboards.new-comments': 'Новые комментарии',
  'dashboards.sales': 'Продажи',
  'dashboards.orders': 'Заказы',
  'dashboards.refunds': 'Возврат',
  'dashboards.recent-orders': 'Последние Заказы',
  'dashboards.product-categories': 'Категории продукта',
  'dashboards.cakes': 'Торты',
  'dashboards.tickets': 'Билеты',
  'dashboards.calendar': 'Календарь',
  'dashboards.best-sellers': 'Бестселлеры',
  'dashboards.per-session': 'За сеанс',
  'dashboards.profile-status': 'Статус профиля',
  'dashboards.payment-status': 'Статус платежа',
  'dashboards.work-progress': 'Ход работы',
  'dashboards.tasks-completed': 'Выполненные задачи',
  'dashboards.payments-done': 'Платежи выполнены',
  'dashboards.order-stock': 'Заказ - Склад',
  'dashboards.categories': 'Категории',
  'dashboards.quick-post': 'Быстрый пост',
  'dashboards.title': 'Заголовок',
  'dashboards.content': 'Содержание',
  'dashboards.ticket-count': 'Количество билетов',
  'dashboards.commonticketsubmission': 'Частые обращения в службу поддержки',
  'dashboards.category': 'Категория',
  'dashboards.save-and-publish': 'Сохранить и опубликовать',
  'dashboards.top-viewed-posts': 'Самые просматриваемые сообщения',
  'dashboards.posts': 'Сообщения',
  'dashboards.pending-for-publish': 'В ожидании публикации',
  'dashboards.users': 'Пользователи',
  'dashboards.on-approval-process': 'В процессе утверждения',
  'dashboards.alerts': 'Оповещения',
  'dashboards.waiting-for-notice': 'Ожидание уведомления',
  'dashboards.files': 'Файлы',
  'dashboards.pending-for-print': 'В ожидании печати',
  'dashboards.logs': 'Журналы',
  'dashboards.gogo': 'ГОГО',
  'dashboards.magic-is-in-the-details': 'МАГИЯ В ДЕТАЛЯХ',
  'dashboards.yes-it-is-indeed': 'Да, это действительно так!',
  'dashboards.advanced-search': 'Расширенный поиск',
  'dashboards.toppings': 'Начинки',
  'dashboards.type': 'Тип',
  'dashboards.keyword': 'Ключевое слово',
  'dashboards.search': 'Поиск',
  'dashboards.top-rated-items': 'Товары с самым высоким рейтингом',
  'dashboards.country': 'Страна',
  'dashboards.webVisitors': 'Посетители сайта',
  'dashboards.avatarClicks': 'Клики по аватару',
  'dashboards.wordCloud': 'Облако слов',
  'dashboards.topic': 'Тема',
  'dashboards.name': 'Имя',
  'dashboards.button': 'Кнопка',
  'dashboards.visits': 'Посещения',
  'dashboards.checkAvailability': 'Проверить доступность или цены',
  'dashboards.details': 'Подробности',
  'dashboards.roomsAvailability': 'Номера и доступность',
  'dashboards.startChat': 'Начать чат',
  'dashboards.restaurantsBars': 'Рестораны и бары',
  'dashboards.groupBooking': 'Групповое бронирование',
  'dashboards.promotions': 'Акции',
  'dashboards.weedingevents': 'Свадьбы и мероприятия',
  'dashboards.lostsomething': 'Потеряли что-то',
  'dashboards.producttext': 'Текст продукта',
  'dashboards.bookingroomnew': 'Бронирование новой комнаты',
  'dashboards.email': 'Электронная почта',
  'dashboards.phone': 'Телефон',
  'dashboards.zipcode': 'Почтовый индекс',
  'dashboards.marketingconsent': 'Согласие на маркетинг',
  'dashboards.additionalinfo': 'Дополнительная информация',
  'dashboards.viewallcontacts': 'Просмотреть все контакты',
  'dashboards.current': 'Текущий',
  'dashboards.last7days': 'Последние 7 дней',
  'dashboards.last30days': 'Последние 30 дней',
  'dashboards.thisweek': 'На этой неделе',
  'dashboards.thismonth': 'В этом месяце',
  'dashboards.previousmonth': 'Предыдущий месяц',
  'dashboards.yeartodate': 'С начала года',
  'dashboards.lastyear': 'Прошлый год',
  'dashboards.all': 'Все',
  'dashboards.standardOccupancy': 'Стандартная заполняемость',
  'dashboards.max-occupancy': 'Максимальная заполняемость',
  'dashboards.numberOfThisType': 'Количество этого типа',
  'dashboards.displayOrder': 'Порядок отображения',
  'dashboards.provider': 'Поставщик',
  'dashboards.edit': 'Редактировать',
  'dashboards.delete': 'Удалить',
  'dashboards.addImages': 'Добавить изображения',
  'dashboards.location_ip':
    'Приблизительное местоположение, определено по IP‑адресу',
  'dashboards.near': 'Рядом',
  'dashboards.referral': 'Пользователь перешёл на вашу страницу с этого сайта',
  'dashboards.calling_party': 'Абонент‑инициатор',
  'dashboards.called_party': 'Абонент‑адресат',
  'dashboards.lastdial': 'Последний звонок',
  'dashboards.imagelink': 'Ссылка на изображение',
  'dashboards.browsegallery': 'Просмотреть галерею',
  'dashboards.changelog': 'Журнал изменений',
  'dashboards.externalresources': 'Внешние ресурсы',
  'dashboards.webpage': 'Веб-страница',
  'dashboards.web-pages': 'Веб-страницы',
  'dashboards.published': 'Опубликовано',
  'dashboards.adddocument': 'Добавить документ',
  'dashboards.ready-to-publish': 'Готово к публикации',
  'dashboards.draft': 'Черновик',
  'dashboards.order-by': 'Сортировать по',
  'dashboards.add-faq': 'Добавить FAQ',
  'dashboards.collections': 'Коллекции',
  'dashboards.items': 'Предметы',
  'dashboards.rooms-availability': 'Номера и наличие',
  'dashboards.events-wedding-venues': 'События и свадебные площадки',
  'dashboards.long-stay-enquiry': 'Запрос на длительное пребывание',
  'dashboards.reservation-confirmation-request':
    'Запрос подтверждения бронирования',
  'dashboards.modify-cancel-booking': 'Изменить или отменить бронирование',
  'dashboards.left-something-behind': 'Забыли что-то',
  'dashboards.invoice-copy': 'Копия счета / чека',
  'dashboards.sync': 'Синхронизировать',
  'dashboards.syncNow': 'Синхронизировать сейчас',
  'dashboards.add-web-page': 'Добавить веб‑страницу',
  'dashboards.sprint-title':
    'Познакомьтесь с Sprint — нашей прорывной автоматизацией для обучения модели ИИ в 10 раз быстрее.',
  'dashboards.sprint-description':
    'Sprint работает вместе с вами — чтобы раскрыть креативность, повысить продуктивность и значительно сократить время, необходимое для обучения цифрового помощника.',
  'dashboards.sprint-feature':
    'Функция Sprint предназначена для синхронизации знаний из внешних источников, что делает её ценным инструментом как для начальной настройки, так и для постоянного обновления данных. При запуске на активной системе Sprint изменяет Knowledge Hub на основе ваших настроенных внешних источников, что может напрямую влиять на поведение и ответы, генерируемые ИИ. Для помощи в настройке Sprint свяжитесь с нашей службой поддержки.',
  'dashboards.change-password': 'Сменить пароль',
  'dashboards.sign-out': 'Выйти',
  'dashboards.privacy-policy': 'Политика конфиденциальности',
  'dashboards.help-center': 'Центр помощи',
  'dashboards.switch-account': 'Сменить аккаунт',
  'dashboards.business-settings': 'Настройки бизнеса',
  'dashboards.notifications-allowed': 'Уведомления разрешены',
  'dashboards.dark-theme': 'Темная тема',
  'dashboards.online': 'В сети',
  'dashboards.offline': 'Не в сети',
  'dashboards.invoice-&-payments': 'Счета и платежи',
  'dashboards.upgrade-plan': 'Обновить план',
  'dashboards.add-room': 'Добавить номер',
  'dashboards.room-type': 'Тип номера',
  'dashboards.room-name': 'Название номера',
  'dashboards.how-many-guests': 'Всего гостей в номере',
  'dashboards.numberofBeds': 'Количество кроватей',
  'dashboards.number-of-rooms-this-type': 'Количество номеров (этого типа)',
  'dashboards.number-of-bedrooms': 'Количество спален',
  'dashboards.number-of-livingrooms': 'Количество гостиных',
  'dashboards.minimum-adults': 'Минимальное количество взрослых',
  'dashboards.maximum-adults': 'Максимальное количество взрослых',
  'dashboards.maximum-children': 'Максимальное количество детей',
  'dashboards.maximum-infants': 'Максимальное количество младенцев',
  'dashboards.extra-beds-allowed': 'Разрешить дополнительную кровать',
  'dashboards.booking-engine-code': 'Код системы бронирования',
  'dashboards.room-size': 'Размер комнаты',
  'dashboards.balcony-area': 'Площадь балкона',
  'dashboards.unit': 'Единица',
  'dashboard.whatsapp_message': 'Введите ваше сообщение здесь...',
  'dashboard.whatsapp_reply_window':
    'У вас есть 24 часа, чтобы ответить на сообщение клиента в WhatsApp Business с момента его последнего сообщения. Если вы отвечаете в течение этого 24-часового окна обслуживания клиентов, вы можете отправлять любые типы сообщений. После закрытия 24-часового окна вы сможете отправлять сообщения только с использованием предварительно одобренных шаблонов сообщений, которые перезапускают 24-часовое окно при ответе клиента.',
  'dashboards.square-meters': 'Квадратные метры',
  'dashboard.pick_quick_reply': 'Выберите быстрый ответ или введите сообщение',
  'dashboard.hang_in_there':
    'Пожалуйста, подождите, пока мы пытаемся подключить вас!',
  'dashboard.outbound_msg': 'Когда отправлять исходящее сообщение',
  'dashboard.message_sent': 'Ваше сообщение успешно отправлено!',
  'dashboard.failed_msg': 'Не удалось отправить сообщение',
  'dashboard.new_chat_message': 'Новое сообщение чата',
  'dashboard.user_msg':
    'За последние 24 часа есть сообщение от пользователя. Вы можете ответить любым сообщением. Вы всё ещё хотите отправить это шаблонное сообщение или ответить другим сообщением?',
  'dashboard.us_number':
    'Сообщения WhatsApp Business не отправляются на номера США, поскольку Meta приостановила все маркетинговые сообщения на номера США с 1 апреля 2025 года.',
  'dashboard.error_msg': 'Пожалуйста, корректно заполните все заполнители.',

  'web-widget.title': 'Меню веб-виджетов для чат-бота сайта',
  /*Home page*/
  'dashboards.quickstartwithai': 'Быстрый старт с ИИ',
  'dashboards.fastestpathtoautomation':
    'Вы на самом быстром пути к автоматизации с инструментами ИИ',
  'dashboards.insightsthatempower': 'Инсайты, которые дают силу',
  'dashboards.trainchatbot': 'Обучить чат‑бота',
  'dashboards.automatewithforms': 'Автоматизация с формами',
  'dashboards.inroomdigitalcompendium': 'Цифровой справочник в номере',
  'dashboards.support': 'Поддержка',
  'dashboards.helpcenter': 'Центр помощи',
  'dashboards.searchfaqintegrations':
    'Ищите статьи о распространённых FAQ, интеграциях и не только.',
  'dashboards.asklivechat': 'Задайте вопрос нашей команде в Live Chat',
  'dashboards.inroomqrcode':
    'QR‑код в номере для просмотра информации об отеле и местоположении',
  'dashboards.customizewebwidget':
    'Настройте и добавьте веб‑виджет на ваш сайт с интегрированным ИИ‑чат‑ботом',
  'dashboards.createcustomforms':
    'Создавайте собственные формы и получайте уведомления, когда гость отправляет форму',
  'dashboards.trainchatbotproperty':
    'Обучите чат‑бота информацией о вашем объекте, например временем заселения, активностями и т. д.',
  'dashboards.chatbotinsights':
    'Узнайте, как ваш чат‑бот взаимодействует с гостями, и получите аналитические данные, такие как посетители сайта, часто задаваемые вопросы и многое другое.',
  'dashboards.addaichatbottoyourwebsite': 'Добавьте ИИ‑чат‑бот на ваш сайт',

  /* Email Stats */
  'dashboards.thread-summary-title': 'Сводки по темам',
  'dashboards.thread-summary-subtitle': 'Сводки писем, сгенерированные ИИ',
  'dashboards.ai-replies-title': 'Ответы ИИ',
  'dashboards.ai-replies-subtitle': 'Ответы, сгенерированные ИИ',
  'dashboards.total-thread-summary-title': 'Всего создано сводок по темам',
  'dashboards.total-ai-replies-title': 'Всего сгенерировано ответов ИИ',
  'dashboards.total-draft-copied': 'Черновики, скопированные пользователями',
  'dashboards.urgency': 'Срочность',
  'dashboards.sentiment': 'Настроение',
  'dashboards.common-email-reasons': 'Распространенные причины писем',
  'dashboards.topics-in-emails': 'Темы в письмах',
  'dashboards.email-assistant-usage': 'Использование AI‑ассистента для писем',
  'dashboards.usage-by-email-address':
    'Использование по адресам электронной почты',

  /* 05.Pages */
  'pages.title.dashboards.analytics': 'Аналитика',
  'pages.title.ari': 'Наличие и цены',
  'pages.title.conversations': 'Разговоры',
  'pages.title.bookings': 'Бронирование и бронирование',
  'pages.title.tickets': 'Лиды и билеты',
  'pages.title.propinfo': 'Ответы',
  'pages.title.discounts': 'Скидки и акции',
  'pages.title.finance': 'Финансы',
  'pages.title.integration': 'Интеграция',
  'pages.title.admin': 'Админ',
  'pages.add-new': 'ДОБАВИТЬ НОВОЕ',
  'pages.add-new-modal-title': 'Добавить новый элемент',
  'pages.display-options': 'Показать варианты',
  'pages.orderby': 'Сортировать по :',
  'pages.product-name': 'наименование товара',
  'pages.category': 'Категория',
  'pages.description': 'Описание',
  'pages.status': 'Положение дел',
  'pages.cancel': 'Отмена',
  'pages.submit': 'Представлять на рассмотрение',
  'pages.delete': 'Удалить',
  'pages.another-action': 'Другое действие',
  'pages.actions': 'ДЕЙСТВИЯ',
  'pages.header': 'Заголовок',
  'pages.details': 'ПОДРОБНОСТИ',
  'pages.orders': 'ЗАКАЗЫ',
  'pages.rating': 'Рейтинг',
  'pages.price': 'Цена',
  'pages.ingredients': 'Ингредиенты',
  'pages.is-vegan': 'веган',
  'pages.order-status': 'Статус заказа',
  'pages.bake-progress': 'Выпечка Прогресс',
  'pages.popularity': 'Популярность',
  'pages.comments': 'Комментарии',
  'pages.error-title': 'Упс... похоже, произошла ошибка!',
  'pages.error-code': 'Код ошибки',
  'pages.go-back-home': 'ВОЗВРАЩАЙСЯ ДОМОЙ',
  'pages.mailing-info':
    'В шаблонах рассылки используются встроенные стили и макет таблицы, чтобы они хорошо отображались у различных поставщиков услуг. Чтобы обеспечить лучшее удобство использования, мы включаем его как обычный HTML-код с опасноSetInnerHTML.',
  'pages.invoice-info':
    'Шаблон счета имеет встроенную версию для использования вне проекта, а также версию React.',
  'pages.react-version': 'Реагировать Версия',
  'pages.inline-version': 'HTML-версия со встроенным стилем',

  /* 06.Applications */

  /* 06.01.Chat */
  'chat.messages': 'Сообщения',
  'chat.contacts': 'Контакты',
  'chat.saysomething': 'Скажите что-то..',

  /* 06.02.Survey */
  'survey.delete': 'Удалить',
  'survey.edit': 'Редактировать',
  'survey.add-new': 'ДОБАВИТЬ НОВОЕ',
  'survey.add-new-title': 'Добавить новый опрос',
  'survey.title': 'Заголовок',
  'survey.category': 'Категория',
  'survey.label': 'Этикетка',
  'survey.status': 'Положение дел',
  'survey.cancel': 'Отмена',
  'survey.submit': 'Представлять на рассмотрение',
  'survey.another-action': 'Еще одна акцияn',
  'survey.display-options': 'Показать варианты',
  'survey.orderby': 'Сортировать по :',
  'survey.all-surveys': 'Все опросы',
  'survey.completed-surveys': 'Завершенные опросы',
  'survey.categories': 'Категории',
  'survey.active-surveys': 'Активные опросы',
  'survey.labels': 'Этикетки',

  /* 06.03.Todo */
  'todo.add-new': 'ДОБАВИТЬ НОВОЕ',
  'todo.add-new-title': 'Добавить все новые',
  'todo.title': 'Заголовок',
  'todo.detail': 'Деталь',
  'todo.category': 'Категория',
  'todo.label': 'Этикетка',
  'todo.status': 'Status',
  'todo.cancel': 'Cancel',
  'todo.submit': 'Submit',
  'todo.action': 'Action',
  'todo.another-action': 'Another action',
  'todo.display-options': 'Display Options',
  'todo.orderby': 'Order By : ',
  'todo.all-tasks': 'All Tasks',
  'todo.pending-tasks': 'Pending Tasks',
  'todo.completed-tasks': 'Completed Tasks',
  'todo.categories': 'Categories',
  'todo.labels': 'Labels',

  /* 07.UI */

  /* 07.01.Alerts */
  'alert.rounded': 'Rounded Alert',
  'alert.react-notifications': 'React Notifications',
  'alert.outline': 'Outline',
  'alert.primary': 'Primary',
  'alert.secondary': 'Secondary',
  'alert.info': 'Info',
  'alert.success': 'Success',
  'alert.warning': 'Warning',
  'alert.error': 'Error',
  'alert.filled': 'Filled',
  'alert.primary-text': 'This is a primary alert—check it out!',
  'alert.secondary-text': 'This is a secondary alert—check it out!',
  'alert.success-text': 'This is a success alert—check it out!',
  'alert.danger-text': 'This is a danger alert—check it out!',
  'alert.warning-text': 'This is a warning alert—check it out!',
  'alert.info-text': 'This is a info alert—check it out!',
  'alert.light-text': 'This is a light alert—check it out!',
  'alert.dark-text': 'This is a dark alert—check it out!',
  'alert.default': 'Default Alert',
  'alert.dismissing': 'Dismissing Alert',
  'alert.dismissing-text':
    'Holy guacamole! You should check in on some of those fields below.',
  'alert.dismissing-without-animate-text':
    'I am an alert and I can be dismissed without animating!',

  /* 07.02.Badges */
  'badge.sizes': 'Sizes',
  'badge.colors': 'Colors',
  'badge.outline': 'Outline',
  'badge.links': 'Links',
  'badge.counter-badges': 'Counter Badges',
  'badge.bootstrap-default': 'Bootstrap Default',
  'badge.primary': 'Primary',
  'badge.secondary': 'Secondary',
  'badge.success': 'Success',
  'badge.danger': 'Danger',
  'badge.warning': 'Warning',
  'badge.info': 'Info',
  'badge.light': 'Light',
  'badge.dark': 'Dark',

  /* 07.03.Buttons */
  'button.default': 'Bootstrap Default',
  'button.colors': 'Colors',
  'button.rounded': 'Rounded',
  'button.outline': 'Outline',
  'button.states': 'States',
  'button.sizes': 'Sizes',
  'button.button-groups': 'Button Groups',
  'button.large-button': 'Large Button',
  'button.small-button': 'Small Button',
  'button.extra-small-button': 'Extra Small Button',
  'button.block-button': 'Block Button',
  'button.active': 'Active',
  'button.disabled': 'Disabled',
  'button.basic': 'Basic',
  'button.toolbar': 'Toolbar',
  'button.nesting': 'Nesting',
  'button.vertical-variation': 'Vertical Variation',
  'button.checkbox-radio-button': 'Checkbox and Radio Button',
  'button.checkbox': 'Checkbox',
  'button.radio': 'Radio',
  'button.radio-button': 'Radio Button',
  'button.primary': 'Primary',
  'button.secondary': 'Secondary',
  'button.success': 'Success',
  'button.danger': 'Danger',
  'button.warning': 'Warning',
  'button.info': 'Info',
  'button.light': 'Light',
  'button.dark': 'Dark',
  'button.states-text':
    'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
  'button.click-here': 'Click Here',
  'button.states-text-alternate':
    'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
  'button.primary-link': 'Primary Link',
  'button.link': 'Link',
  'button.primary-button': 'Primary Button',
  'button.button': 'Button',
  'button.left': 'Left',
  'button.middle': 'Middle',
  'button.right': 'Right',
  'button.dropdown': 'Dropdown',
  'button.dropdown-link': 'Dropdown Link',

  /* 07.04.Cards */
  'cards.icon-card': 'Icon Card',
  'cards.image-card': 'Image Card',
  'cards.image-overlay-card': 'Image Overlay Card',
  'cards.image-card-list': 'Image Card List',
  'cards.tab-card': 'Tab Card',
  'cards.user-card': 'User Card',

  /* 07.05.Carousel */
  'carousel.basic': 'Carousel Basic',
  'carousel.single': 'Carousel Single',
  'carousel.without-controls': 'Carousel Without Controls',

  /* 07.06.Charts */
  'charts.line': 'Line Chart',
  'charts.polar': 'Polar Chart',
  'charts.area': 'Area Chart',
  'charts.scatter': 'Scatter Chart',
  'charts.bar': 'Bar Chart',
  'charts.radar': 'Radar Chart',
  'charts.pie': 'Pie Chart',
  'charts.doughnut': 'Doughnut Chart',
  'charts.shadow': 'Shadow',
  'charts.no-shadow': 'No Shadow',

  /* 07.07.Collapse */
  'collapse.basic': 'Basic',
  'collapse.toggle': 'Toggle',
  'collapse.accordion': 'Accordion',
  'collapse.controlled': 'Controlled',
  'collapse.uncontrolled': 'Uncontrolled',

  /* 07.08.Dropdowns */
  'dropdowns.basic': 'Basic',
  'dropdowns.controlled': 'Controlled',
  'dropdowns.uncontrolled': 'Uncontrolled',
  'dropdowns.dropdown': 'Dropdown',
  'dropdowns.header': 'Header',
  'dropdowns.action': 'Action',
  'dropdowns.another-action': 'Another Action',
  'dropdowns.right': 'Right',
  'dropdowns.left': 'Left',
  'dropdowns.drop-directions': 'Drop Directions',
  'dropdowns.dropright': 'Dropright',
  'dropdowns.dropleft': 'Dropleft',
  'dropdowns.small-button': 'Small Button',
  'dropdowns.large-button': 'Large Button',
  'dropdowns.sizing': 'Sizing',
  'dropdowns.split-button': 'Split Button Dropdowns',
  'dropdowns.dropup': 'Dropup',

  /* 07.09.Editors */
  'editors.draftjs': 'Draft.js',
  'editors.quill-standart': 'Quill Standard',
  'editors.quill-bubble': 'Quill Bubble',

  /* 07.10.Forms */
  'forms.basic': 'Basic',
  'forms.email': 'E-mail',
  'forms.email-muted': "We'll never share your email with anyone else.",
  'forms.password': 'Password',
  'forms.submit': 'Submit',
  'forms.horizontal': 'Horizontal',
  'forms.radios': 'Radios',
  'forms.first-radio': 'First radio',
  'forms.second-radio': 'Second radio',
  'forms.third-radio-disabled': 'Third disabled radio',
  'forms.checkbox': 'Checkbox',
  'forms.signin': 'Sign in',
  'forms.top-labels-over-line': 'Top Labels Over Line',
  'forms.tags': 'Tags',
  'forms.date': 'Date',
  'forms.state': 'State',
  'forms.top-labels-in-input': 'Top Labels In Input',
  'forms.email-u': 'E-MAIL',
  'forms.password-u': 'PASSWORD',
  'forms.tags-u': 'TAGS',
  'forms.date-u': 'DATE',
  'forms.state-u': 'STATE',
  'forms.grid': 'Form Grid',
  'forms.address': 'Address',
  'forms.address2': 'Address 2',
  'forms.city': 'City',
  'forms.city-message': 'Please select a city!',
  'forms.state-message': 'Please select a state!',
  'forms.zip': 'Zip',
  'forms.signup': 'Signup',
  'forms.inline': 'Inline',
  'forms.validation-availity': 'Availity Reactstrap Validation',
  'forms.validation-formik': 'Formik Validation',
  'forms.default': 'Default',
  'forms.firstname': 'First name',
  'forms.firstname-message': 'Please enter your first name!',
  'forms.lastname': 'Last name',
  'forms.lastname-message': 'Please enter your last name!',

  /* 07.11.Form Components */
  'form-components.custom-inputs': 'Custom Inputs',
  'form-components.checkboxes': 'Checkboxes',
  'form-components.radios': 'Radios',
  'form-components.inline': 'Inline',
  'form-components.react-select': 'React Select',
  'form-components.state-single': 'State Single',
  'form-components.state-multiple': 'State Multiple',
  'form-components.react-autosuggest': 'React Autosuggest',
  'form-components.date-picker': 'Date Picker',
  'form-components.date': 'Date',
  'form-components.date-range': 'Date Range',
  'form-components.date-with-time': 'Date with Time',
  'form-components.embedded': 'Embedded',
  'form-components.dropzone': 'Dropzone',
  'form-components.drop-files-here': 'Drop Files Here',
  'form-components.tags': 'Tags',
  'form-components.switch': 'Switch',
  'form-components.primary': 'Primary',
  'form-components.secondary': 'Secondary',
  'form-components.primary-inverse': 'Primary Inverse',
  'form-components.secondary-inverse': 'Secondary Inverse',
  'form-components.slider': 'Slider',
  'form-components.double-slider': 'Double Slider',
  'form-components.single-slider': 'Single Slider',
  'form-components.rating': 'Rating',
  'form-components.interactive': 'Interactive',
  'form-components.readonly': 'Readonly',
  'form-components.type-a-cake': 'Type a Cake',
  'form-components.start': 'Start',
  'form-components.end': 'End',
  'form-components.tables': 'Tables',
  /* 07.12.Icons */
  'icons.simplelineicons': 'Simple Line Icons',
  'icons.iconsmind': 'Iconsmind Icons',

  /* 07.13.Input Groups */
  'input-groups.basic': 'Basic',
  'input-groups.sizing': 'Sizing',
  'input-groups.small': 'Small',
  'input-groups.default': 'Default',
  'input-groups.large': 'Large',
  'input-groups.checkboxes-and-radios': 'Checkboxes and radios',
  'input-groups.multiple-inputs': 'Multiple Inputs',
  'input-groups.first-and-last-name': 'First and last name',
  'input-groups.multiple-addons': 'Multiple Addons',
  'input-groups.button-addons': 'Button Addons',
  'input-groups.button': 'Button',
  'input-groups.buttons-with-dropdowns': 'Buttons with Dropdowns',
  'input-groups.dropdown': 'Dropdown',
  'input-groups.header': 'Header',
  'input-groups.action': 'Action',
  'input-groups.another-action': 'Another Action',
  'input-groups.custom-select': 'Custom Select',
  'input-groups.options': 'Options',
  'input-groups.choose': 'Choose...',
  'input-groups.custom-file-input': 'Custom File Input',

  /* 07.14.Jumbotron */
  'jumbotron.hello-world': 'Hello, world!',
  'jumbotron.lead':
    'This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured content or information.',
  'jumbotron.lead-detail':
    'It uses utility classes for typography and spacing to space content out within the larger container.',
  'jumbotron.learn-more': 'Learn more',

  /* 07.15.Modal */
  'modal.basic': 'Basic',
  'modal.modal-title': 'Modal title',
  'modal.launch-demo-modal': 'Launch Demo Modal',
  'modal.scrolling-long-content': 'Scrolling Long Content',
  'modal.backdrop': 'Backdrop',
  'modal.backdrop-value': 'Backdrop value',
  'modal.right-modal': 'Right Modal',
  'modal.launch-right-modal': 'Launch Right Modal',
  'modal.nested-modal': 'Nested Modal',
  'modal.size': 'Size',
  'modal.launch-large-modal': 'Launch Large Modal',
  'modal.launch-small-modal': 'Launch Small Modal',

  /* 07.16.Navigation */
  'nav.basic': 'Nav Basic',
  'nav.active': 'Active',
  'nav.disabled': 'Disabled',
  'nav.disabled-link': 'Disabled Link',
  'nav.link': 'Link',
  'nav.longer-link': 'Longer nav link',
  'nav.another-link': 'Another Link',
  'nav.right': 'Right',
  'nav.dropdown': 'Dropdown',
  'nav.header': 'Header',
  'nav.action': 'Action',
  'nav.another-action': 'Another Action',
  'nav.horizontal-alignment': 'Nav Horizontal Alignment',
  'nav.vertical-alignment': 'Nav Vertical Alignment',
  'nav.pills': 'Nav Pills',
  'nav.fill-justify': 'Nav Fill and Justify',
  'nav.pills-dropdowns': 'Nav Pills with Dropdowns',
  'nav.pagination-basic': 'Pagination Basic',
  'nav.pagination-sizing': 'Pagination Sizing',
  'nav.large': 'Large',
  'nav.small': 'Small',
  'nav.center': 'Center',
  'nav.pagination-alignment': 'Pagination Alignment',
  'nav.breadcrumb-basic': 'Breadcrumb Basic',

  /* 07.17.Popover & Tooltip */
  'popover-tooltip.popover': 'Popover',
  'popover-tooltip.tooltip': 'Tooltip',

  /* 07.18.Sortable */
  'sortable.columns': 'Sorting Columns',
  'sortable.basic': 'Basic',
  'sortable.handles': 'Handles',

  /* 07.19.Maps */
  'maps.google': 'Google',
  'maps.yandex': 'Яндекс',

  /* 07.20.Tables */
  'table.bootstrap-tables': 'Начальные таблицы',
  'table.bootstrap-basic': 'Базовая таблица',
  'table.bootstrap-striped': 'Полосатые ряды',
  'table.bootstrap-bordered': 'Стол с рамкой',
  'table.bootstrap-borderless': 'Стол без полей',
  'table.bootstrap-hoverable': 'Hoverable ряды',
  'table.bootstrap-responsive': 'Адаптивная таблица',
  'table.react-tables': 'Таблицы реакции',
  'table.react-pagination': 'Пагинация',
  'table.react-scrollable': 'Прокручиваемый',
  'table.react-advanced': 'Фильтр, длина и прыжок',

  /* Property Info */
  'property-info.allcustomers': 'Bce клиенты',
  'property-info.external-sources': 'Внешние источники',
  'property-info.faq': 'Часто задаваемые вопросы',
  'property-info.documents': 'Документы',
  'property-info.publish-ai': 'Опубликовать с ИИ',
  'property-info.pre-built-templates': 'Готовые шаблоны',
  'property-info.room-types': 'Типы комнат',
  'property-info.about-property': 'О собственности',
  'property-info.about-properties': 'О свойствах',
  'property-info.facilities-services': 'Удобства & Услуги',
  'property-info.property-facilities': 'Объекты недвижимости',
  'property-info.room-amenities': 'Удобства в номере',
  'property-info.property-contact': 'Контакт с недвижимостью',
  'property-info.property-activities': 'Деятельность по недвижимости',
  'property-info.property-location': 'Расположение объекта',
  'property-info.about-rooms': 'О комнатах',
  'property-info.about-sites': 'О сайтах',
  'property-info.special-emergencies': 'Чрезвычайные ситуации',
  'property-info.gallery': 'Галерея',
  'property-info.policies': 'Политики',
  'property-info.nearby': 'Рядом',
  'property-info.transport': 'Транспорт',
  'property-info.location': 'Место нахождения',
  'property-info.about-rhproperty': 'О доме престарелых',
  'property-info.related-topics': 'Похожие темы',
  'property-info.assistant-options': 'Меню помощника',
  'property-info.restaurant-assistant-information': 'Информация о ресторане',
  'property-info.restaurant-assistant-options': 'Приветственное сообщение',
  'property-info.channel-messages': 'Сообщения канала',
  'property-info.icon.gallery': 'Галерея иконок',
  'property-info.copilot': 'Второй пилот',
  'property-info.sprint': 'Спринт',
  'property-info.home-information': 'Главная Информация',
  'property-info.loction': 'Места',
  'property-info.rooms-and-images': 'Комнаты и изображения',
  'property-info.trainig-data': 'Тренировочные данные',
  'property-info.flows': 'Потоки',
  'property-info.add-your-own': 'Добавьте свой собственный',
  'property-info-utility-miscellaneous': 'Разнообразный',
  'property-info-utility-payment': 'Платежи',
  'property-info-utility-broadband': 'Широкополосный доступ',
  'property-info-utility-emergency': 'Чрезвычайная ситуация',
  'property-info-utility-mobile': 'мобильный',
  'property-info-utility-moving': 'Движущийся',
  'property-info.publishMonitor': 'Публикация и мониторинг',
  'property-info.webWidget': 'Виджет веб-сайта',
  'property-info.media': 'Медиа',
  /** Rate & Promo */
  'rate-promo.rate-plans': 'Тарифные планы',
  'rate-promo.rate-plan-addons': 'Дополнения',
  'rate-promo.rate-plan-promos': 'Промо',

  'title.property-information': 'Информация о собственности',

  'property.message': 'Сообщение',
  'property.example': 'Пример',
  'property.link': 'Ссылки',
  'property.image-carousel': 'Карусель изображений',
  'property.Title': 'Заголовок',
  'property.SubTitle': 'Подзаголовок',

  'property.add-invoke-api': 'Вызов API',
  'property.add-message-button': 'Добавить сообщения',
  'property.add-img-button': 'Добавить изображения',
  'property.add-link-button': 'Добавить ссылку',
  'property.add-herocard-button': 'Добавить карту героя',
  'property.add-api-button': 'Добавить кнопки',

  'menu.settings': 'Настройки',
  'menu.workflows': 'Рабочие процессы',
  'menu.product_services': 'Продукты и услуги',
  'menu.product_recommander': 'Рекомендации продуктов',
  'menu.digital_guide_book': 'Цифровое руководство',
  'menu.welcome_message': 'Приветственное сообщение',
  'menu.about-property': 'О недвижимости',
  'menu.property-facilities': 'Удобства недвижимости',
  'menu.room-amenities': 'Удобства в номере',
  'menu.property-contact': 'Контакты недвижимости',
  'menu.about-rooms': 'Номера',
  'menu.special-emergencies': 'Чрезвычайные ситуации',
  'menu.show-filter': 'Фильтры',
  'menu.new': 'Новый',
  'menu.channel': 'Каналы',
  'menu.application': 'Приложения',
  'menu.content-manager': 'Менеджер контента',
  'menu.events-calendar': 'Календарь событий',
  'menu.appearance-settings': 'Внешний вид и настройки',

  'dashboards.send': 'Отправить',
  'dashboards.hello': 'Здравствуйте',
  'dashboards.notificationsAllowed': 'Уведомления разрешены',
  'dashboards.allowNotifications': 'Разрешить уведомления',
  'dashboards.views': 'Просмотры',
  'dashboards.bookingURL': 'URL бронирования',
  'dashboards.searchTags': 'Поисковые метки',
  'dashboards.searchCategoryTags': 'Метки категории поиска',
  'dashboards.bedroom': 'Спальня',
  'dashboards.addBedroom': 'Добавить спальню',
  'dashboards.frequency': 'Частота',
  'dashboards.includeSubpages': 'Включить подстраницы',
  'dashboards.enableFaqs': 'Включить FAQ',
  'dashboards.faqsDescription':
    'Включение FAQ позволяет вводить вопросы, при этом система извлекает соответствующие ответы из содержимого веб-страницы для создания всесторонних FAQ',
  'dashboards.faq': 'FAQ',
  'dashboards.deleteDocument': 'Удалить документ',
  'dashboards.confirmDelete': 'Вы уверены, что хотите удалить?',
  'dashboards.addItem': 'Добавить элемент',
  'dashboards.addFirstWebPage': 'Добавьте вашу первую веб-страницу',

  'dashboards.popular-compendium': 'Популярные элементы меню компендиума',
  'dashboards.wordcloudofcompendium': 'Облако слов элементов меню компендиума',
  'dashboards.wordcloudonthings':
    'Облако слов по вопросам посетителей сайта и пунктам меню',
  'dashboards.common-asked': 'Часто задаваемые вопросы',
  'dashboards.website-visitor-asking': 'О чем спрашивают посетители веб-сайта',
  'dashboards.visit-country': 'Посещение веб-сайта по странам',
  'dashboards.visit-traffic': 'Страна посещаемости сайта',
  'dashboards.rooms-product': 'Номера и продукты',
  'dashboards.popular-room-product': 'Популярные номера и продукты',
  'dashboards.connect': 'Подключить',
  'dashboards.messenger-stats': 'Популярные пункты меню',
  'dashboards.messenger-stats-topic-view': 'Статистика просмотров пунктов меню',
  'dashboards.messenger-stats-visits': 'Виды пунктов меню',
  'dashboards.opening-menu-items':
    'Количество посетителей веб-сайта, открывших пункты меню',
  'dashboards.tickets-by-category': 'Билеты по категориям',
  'dashboards.download': 'Скачать',
  'dashboards.number-totalavatarclick': 'Всего кликов по аватару',
  'dashboards.subscribe-to-reports': 'Подписаться на отчеты',
  'dashboards.clicks': 'Клики',
  'dashboards.leads': 'Ведет',
  'dashboards.hours': 'Часы',
  'dashboards.minutes': 'Минуты',

  'dashboards.ai-chatbot': 'ИИ-чат-бот',
  'dashboards.compendium': 'Компендиум',
  'dashboards.compendium-digital-usage': 'Использование цифрового сборника',
  'dashboards.compendium-unique-visits': 'Сканирование/щелчки по QR-коду',
  'dashboards.compendium-opening-menu-items':
    'Количество просмотренных пунктов меню',
  'dashboards.compendium-total-digital-clicks':
    'Общее количество просмотров пунктов меню',
  'dashboards.compendium-total-qr-code':
    'Общее количество сканирований/кликов QR-кода',
  'dashboards.compendium-avg-menu-items':
    'Среднее количество просмотров пунктов меню за сканирование',
  'dashboards.top-clicked-urls': 'Самые кликаемые URL',
  'dashboards.top-clicked-urls-description': 'Анализ кликов по URL',
  'dashboards.urls': 'URL',
  'dashboards.externalDeleteMessage':
    'Этот документ был создан из внешних источников. Если вы не хотите, чтобы он создавался снова, убедитесь, что связанное расписание синхронизации также удалено.',
  'dashboards.deleteAndGoToExternalSources':
    'Удалить и перейти к внешним источникам',
  'property.delete': 'Удалить',
  'menu.userroles': 'Пользователи и роли',
  'menu.members': 'Члены',
  'menu.guest-pass': 'Гостевой пропуск',
  'menu.ratebookings': 'Тарифы и бронирование',
  'dashboards.engagement-time': 'Время взаимодействия с цифровым помощником',
  'dashboards.conversations-minutes':
    'ВОбщее количество минут и минут разговоров за ночь (с 19:00 до 7:00)',
  'dashboards.visitor-questions': 'Вопросы посетителей',
  'dashboards.recent-queries': 'Последние запросы',
  'dashboards.visitor-saying':
    'Что ваши посетители говорят цифровому помощнику',
  'dashboards.contacts-prechatform-leavemessage':
    'Сохраненные контакты из формы предварительного чата и оставить сообщение',
  'menu.dashboards': 'Инсайты',
  'menu.ari': 'Доступность и цены',
  'menu.conversations': 'Разговоры',
  'menu.conversations.unified-inbox': 'Единый почтовый ящик',
  'menu.conversations.active': 'Активные чаты',
  'menu.conversations.archives': 'Архивы',
  'menu.conversations.missed-responses': 'Пропущенные ответы',
  'menu.conversations.ticket': 'Билеты',
  'menu.conversations.reply-templates': 'Шаблоны ответов',
  'menu.bookings': 'Бронирование и бронирование',
  'menu.tickets': 'Лиды и билеты',
  'menu.propinfo': 'Центр знаний',
  'menu.rate-promos': 'Тарифы и акции',
  'menu.finance': 'Финансы',
  'menu.integration': 'Соединять',
  'menu.admin': 'Администрация и безопасность',
  'menu.favourites': 'Избранное',
  'menu.recommender': 'Ход разговора',
  'menu.assistant-setup': 'Настройка помощника',
  'menu.admin-insights': 'Информация для администраторов',
  'menu.super-admin': 'Суперадминистратор',
  'menu.groups': 'Группы',
  'menu.properties': 'Характеристики',
  'menu.service-provider': 'Поставщики услуг',
  'menu.spaces': 'Пространства',
  'menu.availability': 'Доступность',
  'menu.help': 'Помощь',
  'menu.myAccounts': 'Мои аккаунты',
  'menu.guest-messaging': 'Сообщения гостей',
  'guest-messaging.settings': 'Настройки',
  'guest-messaging.outreach-setup': 'Настройка рассылки',
  'guest-messaging.reservations': 'Бронирования',
  'guest-messaging.insights_logs': 'Аналитика и журналы',
  'guest-messaging.placeholder': 'Модуль Сообщения гостей скоро появится.',
  'guest-messaging.settings.placeholder':
    'Укажите предпочтения сообщений для гостей.',
  'guest-messaging.outreach.placeholder':
    'Настройте рассылочные кампании и шаблоны.',
  'guest-messaging.reservations.placeholder':
    'Управляйте сообщениями о бронированиях.',
  'guest-messaging.reservation-source': 'Источник данных бронирования',
  'guest-messaging.communication-channels': 'Каналы связи',
  'guest-messaging.templates': 'Шаблоны',
  'guest-messaging.link': 'Ссылка',
  'guest-messaging.business-profile': 'Профиль компании',

  'dashboards.space-booking': 'Бронирование помещений',
  'dashboards.gift-voucher': 'Подарочные сертификаты',
  'dashboards.chatbots': 'Чат-боты',
  'dashboards.form': 'От',
  'dashboards.to': 'К',
  'dashboards.active-groups': 'Активные группы',
  'dashboards.active-properties': 'Активные свойства',
  'dashboards.live-properties': 'Живая недвижимость',
  'dashboards.properties-going':
    'Объекты, вводимые в эксплуатацию по диапазону дат',
  'dashboards.start-date': 'Дата начала',
  'dashboards.end-date': 'Дата окончания',

  'dashboards.website-visits': 'Посещения веб-сайта',
  'dashboards.unique-visitors': 'уникальные посетители',
  'dashboards.last-week': 'Прошлая неделя',
  'dashboards.this-week': 'На этой неделе',
  'dashboards.this-month': 'Этот месяц',
  'dashboards.previous-month': 'Прошлый месяц',
  'dashboards.yeartodate': 'С начала года',
  'dashboards.lastyear': 'Прошлый год',
  'dashboards.last-7-days': 'Последние 7 дней',
  'dashboards.last-30-days': 'Последние 30 дней',
  'dashboards.last-60-days': 'Последние 60 дней',
  'dashboards.last-90-days': 'Последние 90 дней',
  'dashboards.conversion-rates': 'Коэффициенты конверсии',
  'dashboards.digital-assistant-engagement':
    'Взаимодействие с цифровым помощником',
  'dashboards.total-overnight-conversations':
    'Всего и ночью (с 19:00 до 7:00) Разговоры',
  'dashboards.percentage-accuracy': 'Охват знаний',
  'dashboards.percentage-conversion': 'Конверсия трафика веб-сайта в чат',
  'dashboards.percentage-avatarclick': 'Трафик веб-сайта к кликам по аватару',
  'dashboards.percentage-negativefeedback':
    'Отрицательный отзыв как процент кликов по аватару',
  'dashboards.percentage-amenties': 'Удобства Запросы',
  'dashboards.percentage-booking': 'Запросы на бронирование',
  'dashboards.percentage-webchats': 'Чаты на сайте',
  'dashboards.percentage-facebookchat': 'Чаты Facebook',
  // 'dashboards.number-webchattime': 'Общее время веб-чата',
  'dashboards.number-webchattime': 'Общее время разговора',
  'dashboards.number-totalconversation': 'Всего разговоров',
  'dashboards.number-websiteconversation': 'Разговоры на сайте',
  'dashboards.number-facebookconversation': 'Разговоры в Facebook',
  'dashboards.number-estimatedtimesaving': 'Расчетная экономия времени',
  'dashboards.number-googlemapsconversation': 'Разговоры на Google Картах',
  'dashboards.number-whatsappconversation': 'Разговоры в WhatsApp',
  'dashboards.number-instagramconversation': 'Разговоры в Инстаграме',
  'dashboards.number-agentconversation': 'Разговоры с агентами',
  'dashboards.number-amenityqueries': 'Удобства Запросы',
  'dashboards.number-bookingenquiries': 'Запросы на бронирование',
  'dashboards.number-groupbookingenquiries':
    'Запросы на групповое бронирование',
  'dashboards.number-eventenquiries': 'Запросы о событиях',
  'dashboards.number-longstayenquiries': 'Запросы на длительное пребывание',
  'dashboards.number-totaltickets': 'Билеты',
  'dashboards.number-returncustomer': 'Вернуть клиента',
  'dashboards.number-redirects': 'Перенаправления веб-сайтов',
  'dashboards.number-bookingengineleads': 'Система бронирования лидов',
  'dashboards.number-roomnightsreferred': 'Количество ночей в номере',
  'dashboards.number-revenuereferred': 'Привлеченный доход',
  'menu.bookingsmenu': 'Бронирование',
  'menu.guests': 'Информация для гостей',
  'menu.whatsnew': 'Что нового',

  'forms.forms-title': 'Форма',
  'menu.formbuilder': 'Конструктор форм',
  'dashboards.trainAI': 'Обучите ИИ с помощью документов',
  'dashboards.uploadDocuments':
    'Загрузите документы, чтобы помочь ИИ узнать больше о вашем бизнесе и помогать клиентам так же, как это делаете вы. Вы можете добавлять файлы в форматах .doc, .pdf или .txt.',
  'dashboards.welcomeMessage': 'Приветственное сообщение',
  'dashboards.personalizeGreeting':
    'Настройте приветствие клиентов так, чтобы оно отражало ваш бренд, стиль и этикет, обеспечивая им самый тёплый приём. Персонализируйте приветствия, чтобы создать тёплую атмосферу и подчеркнуть ваш бренд.',
  'dashboards.addRoomDetails':
    'Добавьте информацию о каждой комнате, чтобы гости могли легко узнать всё необходимое для выбора идеального варианта и сделать процесс бронирования проще и быстрее.',
  'dashboards.trainAIFAQs': 'Обучите ИИ на часто задаваемых вопросах',
  'dashboards.manualQuestions':
    'Некоторые вопросы нельзя ответить через документы или найти на сайте. Здесь вы можете вручную добавить вопросы, чтобы клиенты всегда имели нужную информацию под рукой.',
  'dashboards.publishAI':
    'Опубликуйте ИИ, чтобы отразить самые последние обновления',
  'dashboards.retrainAfterChanges':
    'Когда вы вносите изменения в Knowledge Hub или формы, обязательно переобучите чатбота на обновлённой информации. Публикация вашего ИИ гарантирует, что чатбот будет предоставлять наиболее точные и актуальные ответы.',
  'dashboards.enhanceKnowledge':
    'Улучшайте знания ИИ, отслеживая неотвеченные запросы',
  'dashboards.reviewUnanswered':
    'Когда ИИ не может ответить на вопрос или предоставляет лишь ограниченные сведения, такие запросы вы найдете здесь. Просмотрите их, чтобы выявить пробелы в вашем Knowledge Hub или уникальные вопросы гостей.',
  'dashboards.manageMedia': 'Управление медиа',
  'dashboards.mediaGallery':
    'Каждый раз, когда вы загружаете изображения, такие как номера, удобства, логотипы или ваш цифровой аватар, они появятся в этой галерее, предоставляя вам центральное место для управления визуальными материалами и гарантируя, что ваши гости увидят, что делает ваш бизнес уникальным.',
  'dashboards.createForms':
    'Создавайте формы легко и получайте уведомления при каждой отправке.',
  'dashboards.manageForms':
    'Создавайте и управляйте формами для сбора информации о клиентах, настройте уведомления и настройте их для разных языков.',
  'dashboards.personalizeResponse':
    'Персонализируйте стиль ответа и ход беседы',
  'dashboards.controlConversation':
    'Эта расширенная функция дает вам возможность формировать и контролировать, как развиваются беседы с вашими клиентами через различные каналы.',

  'menu.virtualfrontdesk': 'Виртуальная стойка регистрации',
  'menu.guestservice': 'Услуги для гостей',
  'virtual-front.common-questions': 'Общие вопросы',
  'virtual-front.add-on-upsells': 'Дополнения и допродажи',
  'virtual-front.service-order': 'Сервисные заказы',
  //'virtual-front.guest-service-add-on-upsells': "Гостевые услуги и дополнения",
  'virtual-front.guest-service-add-on-upsells': 'Цифровая гостевая книга',
  'virtual-front.outbound': 'Исходящий',
  'virtual-messenger': 'Мессенджер',

  'missed-response.missed-response-title': 'Заголовок пропущенного ответа',

  //
  'content.allconversation': 'Все разговоры',
  'content.active': 'Активные',
  'content.tickets': 'Тикеты',
  'content.filter': 'Фильтр',
  'content.createtickets': 'Создать тикеты',
  'content.conversation': 'Разговор',
  'content.knowledgesearch': 'Поиск по знаниям',
  'content.reply': 'Ответить',
  'content.visitorinfo': 'Информация о посетителе',
  'content.callinfo': 'Информация о звонке',
  'content.allinsights': 'Все инсайты',
  'content.availabilityrates': 'Доступность и тарифы',
  'content.callback': 'Обратный звонок',
  'content.close': 'Закрыть',
  'content.sms': 'СМС',
  'content.timestamp': 'Отметка времени',
  'content.topics': 'Темы',
  'content.callingparty': 'Звонившая сторона',
  'content.accountdomain': 'Домен аккаунта',
  'content.calledparty': 'Принимающая сторона',
  'content.recording': 'Запись',
  'content.phonesystemoriginationcallid':
    'ID исходящего звонка телефонной системы',
  'content.phonesystemterminationcallid':
    'ID входящего звонка телефонной системы',
  'content.uniqueconversationid': 'Уникальный ID разговора',
  'content.regenerateinsights': 'Обновить инсайты',
  'content.customersentiment': 'Настроение клиента',
  'content.neutral': 'Нейтральный',
  'content.customerreportedbroadbandoutage':
    'Клиент сообщил о сбое широкополосного интернета, предоставив свой ID клиента и дату активации услуги для получения помощи.',
  'content.conversationinsights': 'Анализ разговора',
  'content.broadbandoutage': 'Сбой широкополосного интернета',
  'content.customeridverification': 'Проверка ID клиента',
  'content.serviceactivationdate': 'Дата активации услуги',
  'content.followups': 'Последующие действия',
  'content.actionneeded': 'Требуется действие',
  'content.uniqueConversationId': 'Уникальный ID беседы',
  'content.uniqueChatId': 'Уникальный ID чата',
  'content.recording&transcript': 'Запись и расшифровка',
  'content.chatinsights': 'Анализ чата',
  'content.visitedpages': 'Посещённые страницы',
  'content.deviceinfo': 'Информация об устройстве',
  'content.chatstartedonthispage': 'Чат начат на этой странице',
  'content.prechatinfo': 'Информация до чата',
  'content.notes': 'Заметки',
  'content.reassign': 'Переназначить',
  'content.open': 'Открыть',
  'content.dismiss': 'Закрыть',
  'content.add_placeholder': 'Добавить значения заполнителя',
  'content.mobile_number': 'Мобильный номер',
  'content.please_select': 'Пожалуйста, выберите',
  'content.sendwhatsapp': 'Отправить сообщение в WhatsApp',

  /* Missed Response */
  'feedback.missed-question': 'Пропущенный вопрос',
  'feedback.conversation-summary': 'Сводка беседы',
  'feedback.dates-in-spanish': 'Даты должны быть на испанском языке',
  'feedback.resolve': 'Решить',
  'feedback.ignore': 'Игнорировать',

  //integration
  // ru-RU
  'integration.select_properties': 'Выбрать свойства',
  'integration.select_properties_enabled':
    'Выберите свойства, активированные через эту интеграцию',
  'integration.services_addons': 'Выбрать сервисы и дополнения',
  'integration.services_visible':
    'Выберите, какие сервисы и дополнения будут видны на этой странице',
  'integration.appearance': 'Внешний вид',
  'integration.appearance_customize':
    'Выберите имя вашего цифрового ассистента, аватар и настройте цвета',
  'integration.booking_calendar': 'Календарь бронирований',
  'integration.booking_calendar_style':
    'Выберите оформление всплывающего окна календаря бронирований',
  'integration.nudges': 'Подсказки',
  'integration.nudges_setup':
    'Настройте проактивные сообщения для взаимодействия с посетителями сайта',
  'integration.position': 'Позиция',
  'integration.position_control':
    'Контролируйте положение виджета чата на вашем сайте',
  'integration.custom_fonts': 'Пользовательские шрифты',
  'integration.custom_fonts_upload':
    'Загрузите любые пользовательские шрифты, которые вы хотите использовать на странице',
  'integration.custom_css': 'Пользовательский CSS',
  'integration.custom_css_usage':
    'Используйте CSS для настройки вашего цифрового справочника',
  'integration.location': 'Местоположение',
  'integration.location_embed': 'Добавьте URL встраивания местоположения',
  'integration.external_links': 'Внешние ссылки',
  'integration.external_links_add': 'Добавьте ваши ссылки',
  'integration.language': 'Язык',
  'integration.widget_languages': 'Выберите языки для чат-виджета',
  'integration.chatbot_contact': 'Чатбот ',
  'integration.chatbot_enable': 'Активировать вашего цифрового ассистента',
  'integration.chatbot_security': 'Обеспечьте безопасность вашего мессенджера',
  'integration.chatbot_trusted_pages':
    'Перечислите доверенные страницы для отображения чатбота',
  'integration.chatbot_publish': 'Опубликовать вашего цифрового ассистента',
  'integration.chatbot_install':
    'Скопируйте фрагмент кода для установки вашего цифрового ассистента',
  'integration.google_analytics': 'Отслеживание Google Analytics',
  'integration.google_analytics_desc':
    'Отслеживайте активность пользователей, сессии и ключевые действия в веб-виджете с помощью GA4.',
  'integration.enable_ga4': 'Включить Google Analytics',
  'integration.ga4_measurement_id': 'Идентификатор измерения GA4',
  'integration.ga4_id_example': 'Пример: G-ABCD123456',
  'integration.track_events': 'Отслеживать события',
  'integration.track_events_desc':
    'Выберите, какие действия пользователя отправлять как события GA4.',
  'integration.avatar_click': 'Клик по аватару',
  'integration.avatar_click_desc':
    'Отслеживать, когда пользователь нажимает на аватар чата.',
  'integration.menu_click': 'Клик по меню',
  'integration.menu_click_desc':
    'Отслеживать, когда пользователь открывает меню веб-виджета.',
  'integration.chat_started': 'Чат начат',
  'integration.chat_started_desc':
    'Отслеживать первое сообщение пользователя один раз за сессию.',
  'integration.event_tag': 'Тег события',
  'integration.event_prefix': 'Префикс события',
  'integration.final_tag': 'Итоговый тег',
  'integration.example_event': 'Пример события',
  'integration.once_per_session': 'Только один раз за сессию',
  'integration.saving': 'Сохранение...',
  'integration.save_ga4_settings': 'Сохранить настройки GA4',
};
export default ruMessages;
